/**
 * Swatch Groups — label sync for grouped color swatch fieldsets.
 *
 * When a radio in one swatch group is selected, this script:
 * 1. Shows the selected color name in that group's legend
 * 2. Hides the selected label in all other swatch group fieldsets
 * 3. Toggles standalone subline visibility (shown when no color is selected)
 */
function initSwatchGroups(container) {
  if (container.dataset.swatchGroupsInitialized === "true") return;
  const fieldsets = container.querySelectorAll(".swatch-group-fieldset");
  if (fieldsets.length < 2) return;
  container.dataset.swatchGroupsInitialized = "true";

  container.addEventListener("change", function (event) {
    const target = event.target;
    if (target.type !== "radio") return;

    const activeFieldset = target.closest(".swatch-group-fieldset");
    if (!activeFieldset) return;

    fieldsets.forEach(function (fieldset) {
      const selectedWrap = fieldset.querySelector("[data-swatch-group-selected]");
      const selectedValue = fieldset.querySelector("[data-selected-value]");
      const standaloneSubline = fieldset.querySelector("[data-swatch-group-subline-standalone]");

      if (fieldset === activeFieldset) {
        if (selectedWrap) selectedWrap.style.display = "";
        if (selectedValue) selectedValue.textContent = target.value;
        if (standaloneSubline) standaloneSubline.style.display = "none";
      } else {
        if (selectedWrap) selectedWrap.style.display = "none";
        if (selectedValue) selectedValue.textContent = "";
        if (standaloneSubline) standaloneSubline.style.display = "";
      }
    });
  });
}

function init() {
  document.querySelectorAll("variant-selects").forEach(initSwatchGroups);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
